(() => {
  'use strict';
  function initProduct(root) {
    if (!root || root.dataset.mfInitialized) return;
    root.dataset.mfInitialized = 'true';
    const $ = (selector) => root.querySelector(selector);
    const $$ = (selector) => [...root.querySelectorAll(selector)];
    const gallery = $('[data-mf-gallery-stage]');
    $$('[data-mf-gallery]').forEach(button => {
      button.addEventListener('click', () => {
        $$('[data-mf-gallery]').forEach(item => {
          const selected = item === button;
          item.classList.toggle('selected', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
        const image = $('[data-mf-gallery-image]');
        // Responsive pack sources must not remain active when a serving photo is selected.
        // Set sizes before srcset so the browser chooses the right pack width immediately.
        if (button.dataset.srcset) {
          image.setAttribute('sizes', button.dataset.sizes || '100vw');
          image.setAttribute('srcset', button.dataset.srcset);
        } else {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
        }
        image.src = button.dataset.src;
        image.alt = button.dataset.alt;
        gallery.classList.toggle('is-lifestyle', button.dataset.mfGallery !== 'pack');
        $('[data-mf-gallery-caption]').textContent = button.dataset.caption;
        $('[data-mf-gallery-note]').textContent = button.dataset.mfGallery === 'pack'
          ? 'You receive the powdered mix. Prepared drinks are serving suggestions.'
          : button.dataset.mfGallery === 'iced'
            ? 'Mix warm, then add cold milk and ice. Serving suggestion.'
            : 'Whisk into hot water; add milk or cream to taste. Serving suggestion.';
      });
    });
    const revealNutrition = () => {
      if (window.location.hash === '#nutrition-details') $('#nutrition-details').open = true;
    };
    $$('[data-mf-nutrition-link]').forEach(link => link.addEventListener('click', () => { $('#nutrition-details').open = true; }));
    window.addEventListener('hashchange', revealNutrition);
    revealNutrition();

    const form = $('[data-mf-product-form]');
    const dataElement = $('[data-mf-product-data]');
    if (!form || !dataElement) return;
    let data;
    try { data = JSON.parse(dataElement.textContent); } catch (_) { return; }
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: data.currency });
    const money = cents => formatter.format(cents / 100).replace(/\.00$/, '');
    const variantInput = $('[data-mf-variant]');
    const quantityInput = $('#MFQuantity');
    const plans = $('[data-mf-plans]');
    const addButton = $('[data-mf-add]');
    const sticky = $('[data-mf-sticky]');
    let variant = data.variants.find(item => item.id === variantInput.value) || data.variants[0];
    const selectedPlan = () => plans.querySelector('input[name="selling_plan"]:checked');

    function validateQuantity() {
      const value = Number(quantityInput.value);
      const valid = Number.isInteger(value) && value >= variant.min && (!variant.max || value <= variant.max) && (value - variant.min) % variant.step === 0;
      let message = '';
      if (!valid) {
        message = `Choose a whole quantity of at least ${variant.min}`;
        if (variant.max) message += ` and no more than ${variant.max}`;
        if (variant.step > 1) message += `, in increments of ${variant.step}`;
        message += '.';
      }
      quantityInput.setCustomValidity(message);
      $('[data-mf-quantity-feedback]').textContent = message;
      return valid;
    }
    function updateTotals() {
      const selected = selectedPlan();
      const quantity = Number(quantityInput.value);
      const valid = validateQuantity();
      const price = Number(selected?.dataset.displayPrice ?? variant.displayPrice);
      const total = price * (valid ? quantity : variant.min);
      $('[data-mf-total]').textContent = money(total);
      const units = `${valid ? quantity : variant.min} ${data.unit}${quantity === 1 ? '' : 's'}`;
      const planText = selected?.value ? (data.isRetail ? 'Monthly delivery' : selected.dataset.planName) : 'One-time';
      $('[data-mf-plan-detail]').textContent = selected?.value
        ? `${units} · ${money(total)} per delivery before shipping and tax. ${planText}. Renews automatically until canceled.`
        : `One-time purchase. ${units} · ${money(total)} before shipping and tax. No recurring delivery.`;
      const stickySummary = $('[data-mf-sticky-summary]');
      if (stickySummary) stickySummary.textContent = `${planText} · ${money(total)}`;
      const decrease = $('[data-mf-quantity="-1"]');
      const increase = $('[data-mf-quantity="1"]');
      decrease.disabled = valid && quantity <= variant.min;
      increase.disabled = valid && Boolean(variant.max) && quantity + variant.step > variant.max;
    }
    function planOption({ id = '', name = 'Buy once', price, displayPrice }) {
      const label = document.createElement('label');
      label.className = 'purchase-option';
      const input = document.createElement('input');
      input.type = 'radio'; input.name = 'selling_plan'; input.value = id;
      input.dataset.price = String(price); input.dataset.displayPrice = String(displayPrice);
      input.dataset.planName = name;
      const radio = document.createElement('span');
      radio.className = 'radio-ui'; radio.setAttribute('aria-hidden', 'true');
      const copy = document.createElement('span'); copy.className = 'option-copy';
      const strong = document.createElement('strong');
      strong.textContent = id && data.isRetail ? 'Monthly delivery' : name;
      if (id && displayPrice < variant.displayPrice) {
        const saving = document.createElement('span'); saving.className = 'save-label';
        saving.textContent = `SAVE ${money(variant.displayPrice - displayPrice)}`;
        strong.append(saving);
      }
      const description = document.createElement('small');
      description.textContent = id ? (data.isRetail ? 'Your selected quantity. Billed monthly.' : 'Recurring delivery.') : 'A single order.';
      copy.append(strong, description);
      const value = document.createElement('span'); value.className = 'option-price';
      value.append(document.createTextNode(money(displayPrice)));
      const unit = document.createElement('span'); unit.className = 'price-unit'; unit.textContent = `per ${data.unit}`;
      value.append(unit); label.append(input, radio, copy, value);
      return label;
    }
    function changeVariant() {
      variant = data.variants.find(item => item.id === variantInput.value) || data.variants[0];
      const previous = selectedPlan()?.value;
      plans.querySelectorAll('.purchase-option').forEach(item => item.remove());
      if (!data.requiresPlan) plans.append(planOption({ price: variant.price, displayPrice: variant.displayPrice }));
      variant.plans.forEach(plan => plans.append(planOption(plan)));
      const options = [...plans.querySelectorAll('input[name="selling_plan"]')];
      const chosen = options.find(option => option.value === previous) || options[0];
      if (chosen) chosen.checked = true;
      quantityInput.min = variant.min; quantityInput.step = variant.step;
      if (variant.max) quantityInput.max = variant.max; else quantityInput.removeAttribute('max');
      quantityInput.value = variant.min;
      addButton.disabled = !variant.available || !chosen;
      $('[data-mf-add-label]').textContent = variant.available ? 'Add to bag' : 'Sold out';
      $('[data-mf-add-total]').hidden = !variant.available;
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
      updateTotals();
    }
    variantInput.addEventListener('change', changeVariant);
    plans.addEventListener('change', () => {
      const url = new URL(window.location.href);
      if (selectedPlan()?.value) url.searchParams.set('selling_plan', selectedPlan().value); else url.searchParams.delete('selling_plan');
      url.searchParams.delete('plan');
      history.replaceState({}, '', url);
      updateTotals();
    });
    quantityInput.addEventListener('input', updateTotals);
    $$('[data-mf-quantity]').forEach(button => button.addEventListener('click', () => {
      const current = Number(quantityInput.value);
      const base = Number.isFinite(current) ? current : variant.min;
      let next = base + Number(button.dataset.mfQuantity) * variant.step;
      next = variant.min + Math.round((next - variant.min) / variant.step) * variant.step;
      next = Math.max(variant.min, next);
      if (variant.max) next = Math.min(variant.max, next);
      quantityInput.value = next;
      updateTotals();
    }));
    form.addEventListener('submit', event => {
      if (!validateQuantity()) { event.preventDefault(); event.stopImmediatePropagation(); quantityInput.reportValidity(); }
    }, true);
    const params = new URLSearchParams(window.location.search);
    const requestedPlan = params.get('selling_plan');
    const options = [...plans.querySelectorAll('input[name="selling_plan"]')];
    const initialPlan = options.find(option => requestedPlan && option.value === requestedPlan)
      || (params.get('plan') === 'monthly' ? options.find(option => option.value) : null);
    if (initialPlan) initialPlan.checked = true;
    updateTotals();
    if (sticky) {
      let stickyFramePending = false;
      const updateSticky = () => {
        stickyFramePending = false;
        const bounds = form.getBoundingClientRect();
        // The closed chat launcher sits below this bar, but an open support
        // dialog must have its full message area and native focus behavior.
        const chatOpen = Boolean(document.querySelector('shopify-chat[open]'));
        sticky.hidden = chatOpen || bounds.bottom > 0 || bounds.width === 0 || bounds.height === 0;
      };
      const scheduleSticky = () => {
        if (stickyFramePending) return;
        stickyFramePending = true;
        requestAnimationFrame(updateSticky);
      };
      window.addEventListener('scroll', scheduleSticky, { passive: true });
      window.addEventListener('resize', scheduleSticky);
      window.addEventListener('pageshow', scheduleSticky);
      if ('IntersectionObserver' in window) new IntersectionObserver(scheduleSticky).observe(form);
      if ('ResizeObserver' in window) new ResizeObserver(scheduleSticky).observe(form);
      if ('MutationObserver' in window) {
        new MutationObserver(records => {
          const chatChanged = records.some(record => record.type === 'attributes'
            ? record.target.matches('shopify-chat')
            : [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 &&
              (node.matches('shopify-chat') || node.querySelector('shopify-chat'))));
          if (chatChanged) scheduleSticky();
        }).observe(document.body, { attributes: true, attributeFilter: ['open'], childList: true, subtree: true });
      }
      updateSticky();
    }
  }
  document.querySelectorAll('[data-mf-product]').forEach(initProduct);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-mf-product]').forEach(initProduct);
  });
})();
